import plnLogo from "./assets/pln.png";

window.GlobFunction = {
  getDomain: function () {
    return "Mandiri";
  },
  getAccessToken: function () {
    return "somerandomsuperaccess_token";
  },
  getTokenSecret: function () {
    return "tokensecretwithtophasingsecuretoken";
  },
  getDomainId: function () {
    return "originaliddarinolimit.com";
  },
  getDisplayPicture: function () {
    return plnLogo;
  },
};

const httpUri =
  process.env.REACT_APP_HTTP_HOST || "http://128.199.176.197:9292";
const wsUri = process.env.REACT_APP_WS_HOST || "ws://128.199.176.197:9292";

export const Config = {
  websocketUrl: `${wsUri}/livechat/ws`,
  uploadUrl: `${httpUri}/livechat/media/upload`,
  chatSubjectUrl: `${httpUri}/livechat/chat_subject/list`,
  chatSettingUrl: `${httpUri}/livechat/settings`,
  agentRequestLogUri: `${httpUri}/livechat/agent-request-log`,
  chatHistoryUrl: `${httpUri}/livechat/history`,
  captchaChallengeUrlMobile: `${httpUri}/livechat/settings?is_mobile=true`,
  captchaChallengeUrl: `${httpUri}/livechat/captcha/request-challenge`,
  captchaImageUrl: `${httpUri}/livechat/captcha/image`,
  initialCode: "session:create",
  domain: function () {
    return window.GlobFunction.getDomain();
  },
  accessToken: function () {
    return window.GlobFunction.getAccessToken();
  },
  tokenSecret: function () {
    return window.GlobFunction.getTokenSecret();
  },
  domainId: function () {
    return window.GlobFunction.getDomainId();
  },
  displayPicture: function () {
    return window.GlobFunction.getDisplayPicture();
  },
  userAgent:
    "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_3) AppleWebKit/5.36 (KHTML, like Gecko) Chrome/63.0.3239.132 Safari/537.36",
  timezone: -420,
};
